import { Component } from '@angular/core';
import { IdentityService } from './core/identity/identity.service';


@Component({
    selector: 'app-should-login',
    template: `<p class="alert alert-info">{{ 'should_login.your_session_expired' | t:'Your session expired.' }}</p>
    <p>{{ 'should_login.please' | t:'Please' }} <a href="" (click)="login($event)">{{ 'should_login.log_in' | t:'log in' }}</a> {{ 'should_login.before_continuing' | t:'before continuing.' }}</p>`,
    standalone: false
})
export class ShouldLoginComponent {
  constructor(private authService: IdentityService) { }

  public login($event) {
    $event.preventDefault();

    window.location.replace("/");
  }
}